import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { AppService } from '../../../services/app.service';
import { NotificationService } from '../../../services/notification.service';
import { ITableColumn } from '../../../shared/table/table.component';
import { INotificationListItem, notificationStatuses, } from '../../../models/Notification';
import { Utils } from '../../../core/Utils';

interface IFilterListItem {
    text: string;
    value: string;
}

@Component({
    selector: 'app-notification-outbox',
    templateUrl: './notification-outbox.component.html'
})
export class NotificationOutboxComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: NotificationService
    ) { }

    rows: INotificationListItem[] = [];
    hasMore: boolean;
    limit: number = 300;

    readonly columns: ITableColumn[] = [
        { property: 'Id', label: 'notification_lblId', type: 'number', sorts: true },
        { property: 'Status', label: 'notification_lblStatus', sorts: true },
        { property: 'Sender', label: 'notification_lblSender', sorts: true },
        { property: 'Finished', label: 'notification_lblFinished', type: 'date', sorts: true },
        { property: 'Type', label: 'notification_lblType', sorts: true },
        { property: 'Subject', label: 'notification_lblSubject', sorts: true },
        { width: '1px' }
    ];

    readonly isAdmin = this.app.currentUser.rights.includes('NOTIFICATION.ADMIN');

    readonly options: {
        status: IFilterListItem[],
        type: IFilterListItem[]
    } = {
            status: notificationStatuses.map(t => {
                return {
                    text: this.app.translate(`notification_status` + t),
                    value: t
                };
            }),
            type: []
        };

    readonly filterValues: {
        id?: string,
        author?: string,
        status: string[],
        type: string[],
        sentFrom?: Date,
        sentTo?: Date
    } = {
            status: [],
            type: []
        };

    private allRows: INotificationListItem[] = [];
    private readonly searchSubj = new Subject<string>();

    ngOnInit() {
        this.searchSubj.pipe(debounceTime(300), distinctUntilChanged()).subscribe(term => {
            this.filter();
        });

        this.fetch();
    }

    filter() {
        const id = (this.filterValues.id || '');
        const author = (this.filterValues.author || '');
        const { status, type, sentFrom, sentTo } = this.filterValues;

        let rows: INotificationListItem[] = [];

        if (!id && !author && !status.length && !type.length && !sentFrom && !sentTo) {
            rows = this.allRows;
        } else {
            rows = this.allRows.filter(t => {
                if (status.length && !status.includes(t.Status)) return false;
                if (type.length && !type.includes(t.Type)) return false;
                if (sentFrom && (!t.Sent || t.Sent < sentFrom)) return false;
                if (sentTo && (!t.Sent || t.Sent > sentTo)) return false;
                if (id && !t.Id.toString().includes(id)) return false;
                if (id && !t.Id.toString().includes(id)) return false;
                if (author && !`${t.AuthorName} ${t.AuthorSurname} ${t.AuthorUpn}`.toLowerCase().includes(author)) return false;

                return true;
            });
        }

        this.rows = [...rows];
    }

    search(term: string) {
        this.searchSubj.next(term);
    }

    loadAll() {
        this.limit = -1;
        this.fetch();
    }

    private fetch() {
        this.app.addLoading(this.service.get(this.limit)).subscribe(data => {
            const type: string[] = [];

            this.hasMore = data.HasMore;

            data.Items.forEach(t => {
                t.Created = Utils.ensureDate(t.Created);

                if (t.Sent) {
                    t.Sent = Utils.ensureDate(t.Sent);
                }

                if (!type.includes(t.Type)) type.push(t.Type);
            });

            this.options.type = type.map(t => {
                return {
                    text: t,
                    value: t
                };
            });

            this.rows = data.Items;
            this.allRows = data.Items;
        });
    }
}
